import { HomeOutlined } from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isRoot?: boolean;
}

export enum Route {
  PRIVACY = 'PRIVACY',
  SUPPORT = 'SUPPORT',
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  VERIFICATION = 'VERIFICATION',
  RESET_PASSWORD = 'RESET_PASSWORD',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',

  HOME = 'HOME',
  CLOUD = 'CLOUD',
  PLAYLIST = 'PLAYLIST',
  PLAYLIST_LIST = 'PLAYLIST_LIST',
  PLAYLIST_HISTORY = 'PLAYLIST_HISTORY',
  DEVICE = 'DEVICE',
  ACCOUNT = 'ACCOUNT',
  PAYMENT = 'PAYMENT',

  SHARE = 'SHARE',
  LIST_SHARED = 'LIST_SHARED',
  LIST_IS_SHARED = 'LIST_IS_SHARED',
  LIST_SHARING = 'LIST_SHARING',

  SETTING = 'SETTING',
  SETTING_SOUND_QUALITY = 'SETTING_SOUND_QUALITY',
  SETTING_CATEGORY_NEWS = 'SETTING_CATEGORY_NEWS',
  SETTING_AREA = 'SETTING_AREA',
  SETTING_AREA_PROVINCE = 'SETTING_AREA_PROVINCE',
  SETTING_AREA_COMMUNE = 'SETTING_AREA_COMMUNE',
  SETTING_AREA_VILLAGE = 'SETTING_AREA_VILLAGE',
  SETTING_ICECAST = 'SETTING_ICECAST',
  SETTING_PACKAGE = 'SETTING_PACKAGE',
  SETTING_ERROR = 'SETTING_ERROR',
  SETTING_CONFIG = 'SETTING_CONFIG',

  LOG = 'LOG',

  // PROFILE = 'PROFILE',
}

export const Routes: { [key in Route]: IRoute } = {
  PRIVACY: {
    path: '/chinh-sach',
    title: 'Chính sách',
  },
  SUPPORT: {
    path: '/ho-tro',
    title: 'Hỗ trợ',
  },
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },
  REGISTER: {
    path: '/dang-ky',
    title: 'Đăng ký',
  },
  VERIFICATION: {
    path: '/kich-hoat-tai-khoan',
    title: 'Kích hoạt tài khoản',
  },
  RESET_PASSWORD: {
    path: '/dat-lai-mat-khau',
    title: 'Đặt lại mật khẩu',
  },
  FORGOT_PASSWORD: {
    path: '/quen-mat-khau',
    title: 'Quên mật khẩu',
  },

  HOME: {
    path: '/',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },
  CLOUD: {
    path: '/noi-dung',
    title: 'Quản lý nội dung',
    // icon: <HomeOutlined />,
  },
  PLAYLIST: {
    path: '/l',
    title: 'Quản lý lịch phát',
    // icon: <HomeOutlined />,
  },
  PLAYLIST_LIST: {
    path: '/lich-phat',
    title: 'Lịch phát',
    // icon: <HomeOutlined />,
  },
  PLAYLIST_HISTORY: {
    path: '/lich-su-phat',
    title: 'Lịch sử phát',
    // icon: <HomeOutlined />,
  },
  DEVICE: {
    path: '/thiet-bi',
    title: 'Quản lý thiết bị',
    // icon: <HomeOutlined />,
  },
  ACCOUNT: {
    path: '/tai-khoan',
    title: 'Quản lý tài khoản',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  PAYMENT: {
    path: '/thanh-toan',
    title: 'Thanh toán',
    // icon: <HomeOutlined />,
  },

  SHARE: {
    path: '/chia-se',
    title: 'Chia sẻ thiết bị',
    // icon: <HomeOutlined />,
  },
  LIST_SHARED: {
    path: '/danh-sach-da-chia-se',
    title: 'Đã chia sẻ',
    // icon: <HomeOutlined />,
  },
  LIST_IS_SHARED: {
    path: '/danh-sach-duoc-chia-se',
    title: 'Được chia sẻ',
    // icon: <HomeOutlined />,
  },
  LIST_SHARING: {
    path: '/danh-sach-dang-cho-chap-nhan',
    title: 'Đang chờ chấp nhận',
    // icon: <HomeOutlined />,
  },

  SETTING: {
    title: 'Cài đặt',
    path: '/c',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_AREA: {
    path: '/sa',
    title: 'Quản lý địa bàn',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_AREA_COMMUNE: {
    path: '/phuong-xa',
    title: 'Quản lý phường xã',
    // icon: <HomeOutlined />,
    isRoot: true,
  },

  SETTING_AREA_PROVINCE: {
    path: '/tinh-thanh',
    title: 'Quản lý tỉnh thành',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_AREA_VILLAGE: {
    path: '/thon-xom',
    title: 'Quản lý thôn xóm',
    // icon: <HomeOutlined />,
  },
  SETTING_CATEGORY_NEWS: {
    path: '/linh-vuc-tin-tuc',
    title: 'Lĩnh vực tin tức',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_SOUND_QUALITY: {
    path: '/chat-luong-am-thanh',
    title: 'Chất lượng âm thanh',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_ICECAST: {
    path: '/icecast',
    title: 'Icecast',
    // icon: <HomeOutlined />,
  },
  SETTING_PACKAGE: {
    path: '/goi-gia-han',
    title: 'Gói gia hạn',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_ERROR: {
    path: '/loi-thiet-bi',
    title: 'Định nghĩa lỗi',
    // icon: <HomeOutlined />,
    isRoot: true,
  },
  SETTING_CONFIG: {
    path: '/cau-hinh-he-thong',
    title: 'Cấu hình hệ thống',
    // icon: <HomeOutlined />,
    isRoot: true,
  },

  LOG: {
    path: '/nhat-ky-hoat-dong',
    title: 'Nhật ký hoạt động',
    // icon: <HomeOutlined />,
    // isRoot: true,
  },
};
